import { render } from "./Comiss.vue?vue&type=template&id=c0c0a81c&scoped=true"
import script from "./Comiss.vue?vue&type=script&lang=js"
export * from "./Comiss.vue?vue&type=script&lang=js"

import "./Comiss.vue?vue&type=style&index=0&id=c0c0a81c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c0a81c"]])

export default __exports__